(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*============================================================================
    Mobile Menu (GSAP animated expand/collapse).
  ============================================================================*/
  (function() {
    const toggle = document.querySelector('.header__menu-toggle');
    const menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;

    const headerEl = document.querySelector('header');
    const logo = document.querySelector('.header__heading');
    const iconHamburger = toggle.querySelector('.icon-hamburger');
    const iconClose = toggle.querySelector('.icon-close');
    let menuOpen = false;

    function getLogoCenterOffset() {
      const headerRect = headerEl.getBoundingClientRect();
      const logoRect = logo.getBoundingClientRect();
      const logoCenter = logoRect.left + logoRect.width / 2;
      const headerCenter = headerRect.left + headerRect.width / 2;
      return headerCenter - logoCenter;
    }

    toggle.addEventListener('click', () => {
      if (!menuOpen) {
        menu.style.visibility = 'visible';
        gsap.fromTo(menu,
          { height: 0, opacity: 0 },
          { height: 'auto', opacity: 1, duration: 0.4, ease: 'power2.out' }
        );
        // Animate logo to center + 30% bigger
        gsap.to(logo, {
          x: getLogoCenterOffset(),
          scale: 1.3,
          duration: 0.4,
          ease: 'power2.out'
        });
        // Remove header border/shadow
        headerEl.classList.add('header--menu-open');
        iconHamburger.style.display = 'none';
        iconClose.style.display = 'inline-flex';
        toggle.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        menuOpen = true;
      } else {
        gsap.to(menu, {
          height: 0,
          opacity: 0,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => { menu.style.visibility = 'hidden'; }
        });
        // Restore logo
        gsap.to(logo, {
          x: 0,
          scale: 1,
          duration: 0.3,
          ease: 'power2.in'
        });
        // Restore header border/shadow
        headerEl.classList.remove('header--menu-open');
        iconHamburger.style.display = 'inline-flex';
        iconClose.style.display = 'none';
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        menuOpen = false;
      }
    });
  })();

  /*============================================================================
    StickyHeader.
      Calculates own header height and manages scroll behavior.
  ============================================================================*/
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerBounds = {};
      
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      
      // Calculate total height of all header group sections
      const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
      let totalHeight = 0;
      headerGroupSections.forEach(section => {
        totalHeight += section.offsetHeight;
      });
      document.documentElement.style.setProperty('--header-group-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loading-screen"]) return;
  try {
    
  (function () {
    const screen = document.getElementById('loading-screen');
    const bar = document.getElementById('loader-progress-bar');
    if (!screen || !bar) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Under reduced motion, remove the autoplaying loader video entirely.
    const loaderVid = document.getElementById('loader-video');
    if (reduceMotion && loaderVid) {
      loaderVid.removeAttribute('autoplay');
      loaderVid.pause();
      loaderVid.remove();
    } else if (loaderVid) {
      // Nudge play in case Chrome deferred autoplay during heavy main-thread work.
      const p = loaderVid.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    let dismissed = false;
    function dismiss() {
      if (dismissed) return;
      dismissed = true;

      bar.style.transition = 'width 0.3s ease';
      bar.style.width = '100%';

      document.body.classList.remove('loading');
      screen.style.transition = 'opacity 0.6s ease';
      screen.style.opacity = '0';
      screen.addEventListener('transitionend', () => {
        screen.remove();
        window.dispatchEvent(new CustomEvent('loadingscreen:dismissed'));
      }, { once: true });

      if (window.gsap && !reduceMotion) {
        const header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('.header-wrapper');
        if (header) {
          window.gsap.fromTo(
            header,
            { y: -60, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', clearProps: 'transform' }
          );
        }
      }
    }

    const hardTimeout = setTimeout(dismiss, 8000);

    // Wait helpers — every wait has a per-asset timeout so a single stuck
    // resource can't pin us at the hardTimeout ceiling.
    function waitTimeout(p, ms) {
      return Promise.race([
        p,
        new Promise(resolve => setTimeout(resolve, ms))
      ]);
    }

    function waitVideoCanPlay(video) {
      return new Promise(resolve => {
        if (video.readyState >= 3) return resolve();
        video.addEventListener('canplaythrough', resolve, { once: true });
        video.addEventListener('error', resolve, { once: true });
      });
    }

    function waitVideoFirstFrame(video) {
      return new Promise(resolve => {
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(() => resolve());
          return;
        }
        if (video.currentTime > 0 && !video.paused) return resolve();
        const check = () => {
          if (video.currentTime > 0) {
            video.removeEventListener('timeupdate', check);
            resolve();
          }
        };
        video.addEventListener('playing', () => {
          if (video.currentTime > 0) return resolve();
          video.addEventListener('timeupdate', check);
        }, { once: true });
        video.addEventListener('error', resolve, { once: true });
      });
    }

    function waitImage(img) {
      return new Promise(resolve => {
        if (img.complete && img.naturalWidth > 0) return resolve();
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    }

    const waits = [];

    // Minimum display time so the loader doesn't just flash
    waits.push(new Promise(resolve => setTimeout(resolve, 500)));

    // Wait for Three.js to fire its ready event (dispatched on first animation frame)
    waits.push(waitTimeout(
      new Promise(resolve => window.addEventListener('threejs:ready', resolve, { once: true })),
      5000
    ));

    // Wait for the loader video to actually paint a frame, not just be playable —
    // ensures the user sees the video before we fade out. The video is rendered
    // at opacity:0 with mix-blend-mode pre-applied inline; once first-frame fires
    // we know the next paint will already have blend mode, so it's safe to fade in.
    if (loaderVid && !reduceMotion) {
      const firstFrame = waitVideoCanPlay(loaderVid).then(() => waitVideoFirstFrame(loaderVid));
      firstFrame.then(() => {
        loaderVid.style.opacity = '1';
      });
      waits.push(waitTimeout(firstFrame, 5000));
    }

    // Wait for above-the-fold homepage media inside <main>: tour bg video,
    // music block bg images, shop marquee images. Skip lazy images and
    // preload="none" videos (music visualizers) — they'd always hit timeout.
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) {
      const mainVideos = main.querySelectorAll('video:not([preload="none"])');
      mainVideos.forEach(v => waits.push(waitTimeout(waitVideoCanPlay(v), 4000)));

      const mainImages = main.querySelectorAll('img:not([loading="lazy"])');
      mainImages.forEach(i => waits.push(waitTimeout(waitImage(i), 4000)));
    }

    // Drive progress bar based on resolved count rather than a fixed 60% jump.
    const total = waits.length;
    let resolvedCount = 0;
    bar.style.transition = 'width 0.4s ease';

    waits.forEach(p => p.then(() => {
      resolvedCount += 1;
      // Cap visible progress at 95% — the final 5% is reserved for the dismiss step.
      const pct = Math.min(95, Math.round((resolvedCount / total) * 95));
      bar.style.width = pct + '%';
    }));

    Promise.allSettled(waits).then(() => {
      clearTimeout(hardTimeout);
      setTimeout(dismiss, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
